export const appConfig = process.env.PRO_CONF
export const stsEventCategory = {
  outerLinks: '[跳转外链]',
  downloadApp: '[下载APP]',
  comments: '[查看评论]',
  hotNews: '[热点咨询]',
  sinaCode: '[查看新浪微博]',
  wxCode: '[微信二维码]',
}



// WEBPACK FOOTER //
// ./src/utils/common.js